import { useEffect } from "react";

/**
 * Injects a <script type="application/ld+json"> into <head>
 * keyed by `id` so re-renders update (not duplicate) the schema.
 */
const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!id || !data) return undefined;
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(elId);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, [id, data]);
};

export default useJsonLd;
